"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BallTriangle = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var BallTriangle = function BallTriangle(props) {
  return (
    /*#__PURE__*/
    _react["default"].createElement("svg", {
      height: props.height,
      width: props.width,
      stroke: props.color,
      viewBox: "0 0 57 57",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": props.label
    },
    /*#__PURE__*/
    _react["default"].createElement("g", {
      fill: "none",
      fillRule: "evenodd"
    },
    /*#__PURE__*/
    _react["default"].createElement("g", {
      transform: "translate(1 1)",
      strokeWidth: "2"
    },
    /*#__PURE__*/
    _react["default"].createElement("circle", {
      cx: "5",
      cy: "50",
      r: props.radius
    },
    /*#__PURE__*/
    _react["default"].createElement("animate", {
      attributeName: "cy",
      begin: "0s",
      dur: "2.2s",
      values: "50;5;50;50",
      calcMode: "linear",
      repeatCount: "indefinite"
    }),
    /*#__PURE__*/
    _react["default"].createElement("animate", {
      attributeName: "cx",
      begin: "0s",
      dur: "2.2s",
      values: "5;27;49;5",
      calcMode: "linear",
      repeatCount: "indefinite"
    })),
    /*#__PURE__*/
    _react["default"].createElement("circle", {
      cx: "27",
      cy: "5",
      r: props.radius
    },
    /*#__PURE__*/
    _react["default"].createElement("animate", {
      attributeName: "cy",
      begin: "0s",
      dur: "2.2s",
      from: "5",
      to: "5",
      values: "5;50;50;5",
      calcMode: "linear",
      repeatCount: "indefinite"
    }),
    /*#__PURE__*/
    _react["default"].createElement("animate", {
      attributeName: "cx",
      begin: "0s",
      dur: "2.2s",
      from: "27",
      to: "27",
      values: "27;49;5;27",
      calcMode: "linear",
      repeatCount: "indefinite"
    })),
    /*#__PURE__*/
    _react["default"].createElement("circle", {
      cx: "49",
      cy: "50",
      r: props.radius
    },
    /*#__PURE__*/
    _react["default"].createElement("animate", {
      attributeName: "cy",
      begin: "0s",
      dur: "2.2s",
      values: "50;50;5;50",
      calcMode: "linear",
      repeatCount: "indefinite"
    }),
    /*#__PURE__*/
    _react["default"].createElement("animate", {
      attributeName: "cx",
      from: "49",
      to: "49",
      begin: "0s",
      dur: "2.2s",
      values: "49;5;27;49",
      calcMode: "linear",
      repeatCount: "indefinite"
    })))))
  );
};

exports.BallTriangle = BallTriangle;
BallTriangle.propTypes = {
  height: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  color: _propTypes["default"].string,
  label: _propTypes["default"].string,
  radius: _propTypes["default"].number
};
BallTriangle.defaultProps = {
  height: 80,
  width: 80,
  color: "green",
  radius: 5,
  label: "audio-loading"
};